import React from 'react';

import { Flex } from '../components/common/atom/Layout';
import { Text } from '../components/common/atom/Text';
import PageTemplate from '../components/common/template/PageTemplate';

import { getCDNUrl } from '../lib/image/CDNUrl';

const BrandStoryPage = () => {
  return (
    <PageTemplate noMargin title={PAGE_TITLE}>
      <Flex column width="100%" padding="0 0 2.5rem">
        <BrandStoryImage itemName="brandStory" />
        <BrandSloganContent />
        <BrandStoryContent />
        <BrandStoryImage itemName="brandSlogan" />
      </Flex>
    </PageTemplate>
  );
};

export default BrandStoryPage;

const PAGE_TITLE = '브랜드 스토리';

const BrandStoryImage = ({ itemName }) => (
  <img
    src={getCDNUrl('brand_story', `${itemName}.png`)}
    alt="브랜드 스토리"
    width="100%"
  />
);

const BrandStoryContent = () => {
  const data = [
    '세상 엄마 아빠들을 생각만으로 미소 짓게 하는 아기의 얼굴은 보는 순간 행복해지는 마법 같은 힘이 있죠.',
    '손톱보다 작은 아이의 초음파 사진을 보고도 감격하는 예비 엄마 아빠 그들을 보며 알레시오는 생각했습니다.',
    `“아이 얼굴을 미리 볼 수 있다면 얼마나 뜻 깊은 순간이 될까.”`,
    '임신은 아이를 만나기 위한 소중한 시간이지만 몸과 마음이 힘든 시간이기도 합니다.',
    '우리는 그 시간에 특별한 행복을 선물하고 싶었습니다.',
    '태어날 아이의 얼굴을 예측하는 것만큼이나 알레시오에게 중요한 것은 베이비페이스를 받고 행복한 엄마아빠의 얼굴입니다.',
    '엄마 아빠의 행복이 아이에게 전해지고 사랑을 듬뿍 받고 태어난 아이들이 만들어 나가는 더 따뜻한 세상.',
    '그것이 알레시오가 바라는 미래입니다.',
    '앞으로도 알레시오는 세상에 행복과 사랑을 가져다 주는 서비스와 제품을 만들기위해 노력하겠습니다.',
  ];

  return (
    <Flex column alignItems="flex-start" padding="1.25rem">
      {data.map((item, idx) => (
        <Text
          key={idx}
          size={14}
          lineHeight={1.29}
          style={{ paddingBottom: '1.132rem' }}
        >
          {item}
        </Text>
      ))}
    </Flex>
  );
};

const BrandSloganContent = () => (
  <Text
    size={24}
    weight="bold"
    style={{ paddingTop: '2.5rem', color: '#ff9484' }}
  >
    우리 아기 첫 사진, 베이비페이스
  </Text>
);
